import React from "react";
import ChangelogItem from "./changelog-item";

class ChangelogItemController extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            changeLog: props.changeLog ? props.changeLog : {}
        };
    }

    closeRightMenu = () => {
        this.props.setShowRightMenu(false);
        //this.props.setRightMenuComponent(null);
        this.props.setRemoveRightMenuComponent();
        this.props.setChangeLog(null, null, null)
        this.setState({
            changeLog: null
        })
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.changeLog && (nextProps.changeLog !== nextState.changeLog)){
            this.setState({
                changeLog: nextProps.changeLog
            });
            return true;
        }
        else {
            return false;
        }
    }

    render() {
        return <ChangelogItem {...this.props} closeRightMenu={this.closeRightMenu}/>
    }
}

export default ChangelogItemController;